module.exports = __webpack_public_path__ + "img/patent6.4d53b866.jpg";